import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { ILinksResponse } from "projects/admin/src/app/components/panel/social-media/interface/social-media";
import { environment } from "projects/shared/environments/environment";
import { Observable } from "rxjs";


@Injectable({
  providedIn: 'root'
})

export class FooterService {

  http = inject(HttpClient);

  getSocialMediaLinks(): Observable<ILinksResponse> {
    return this.http.get<ILinksResponse>(`${environment.apiUrl}social-media`, );
  }
}
